import { Jackpot } from '../../../shared/models/jackpot.interface';
import { environment } from '../../../../environments/environment';
import { CagnotteService } from '../../../shared/services/cagnotte.service';
import { LoaderService } from '../../../shared/services/loader.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  DataTableTranslations,
  DataTableParams,
  DataTable,
} from 'angular-datatables-all-versions';
import { ToastyService } from 'ng2-toasty';
import { ViewChild } from '@angular/core';
import * as moment from 'moment';
import { CagnotteFilterComponent } from './cagnotte-filter/cagnotte-filter.component';

@Component({
  selector: 'app-cagnottes-list',
  templateUrl: './cagnottes-list.component.html',
  styleUrls: ['./cagnottes-list.component.css']
})
export class CagnottesListComponent implements OnInit {
  @ViewChild('dataTable', { static: true }) dataTable: DataTable;
  public jackpotsFiltered: Jackpot[] = [];
  private jackpots: Jackpot[] = [];
  public count = 0;
  public limit = 50;
  public jackpotFilter = '';
  public potType = 'private';
  public isCompany = false;
  public site_url: string;
  public offset = 0;
  limits = [25, 50, 100];

  public events: any[];
  private eventSelected = 'all';
  private routeParams: DataTableParams;
  private searchParams: SearchParam;
  public associations: any[];

  public translations = <DataTableTranslations>{
    indexColumn: 'Num.',
    expandColumn: 'Infos.',
    selectColumn: 'Sélectionner',
    paginationLimit: 'Max.',
    paginationText: 'Résultats: {from} - {to} / {total}',
    paginationTotalPages: '/'
  };

  private mangopayPaiementStatuses: Map<string, string> = new Map([
    ['CREATED', 'En attente de paiement'],
    ['SUCCEEDED', 'Paiement effectué'],
    ['FAILED', 'Paiement refusé'],
    ['UNKNOWN', 'Statut inconnu']
  ]);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private toastyService: ToastyService,
    private modalService: NgbModal,
    private cagnotteService: CagnotteService
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    this.router.events.subscribe(evt => {
      if (evt instanceof NavigationEnd) {
        // trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
        // if you need to scroll back to top, here is the right place
        window.scrollTo(0, 0);
      }
    });

    this.site_url = environment.base_url;

    this.associations = this.route.snapshot.data['assocsForFilter'];
    this.associations.sort((a, b) => a.name.localeCompare(b.name));

    this.potType = this.route.snapshot.paramMap.get('type') || 'private';
    this.isCompany = this.potType === 'company';
    this.events = this.route.snapshot.data['eventTypes'].filter(event => {
      if (this.potType === 'company') {
        return 'Entreprise' === event.category;
      } else {
        return 'Particulier' === event.category;
      }
    });
  }

  ngOnInit() { }

  reload(params) {
    let newParams = { ...params };
    // To prevent internal error when the current page number < 1
    if (this.dataTable.page < 1) {
      this.offset = 1;
      newParams.offset = 0;
    }

    newParams['event'] = this.eventSelected;
    const potTypeMap: { [key: string]: string } = { company: 'ENTERPRISE', citizens: 'CITIZEN_SILVER' };
    newParams['pot_type'] = potTypeMap[this.potType] !== undefined ? potTypeMap[this.potType] : this.potType.toUpperCase();

    this.routeParams = newParams;

    this.loaderService.show();
    this.cagnotteService.list(newParams).subscribe(data => {
      this.jackpotsFiltered = [];
      data.charity_pots.forEach((pot: Jackpot) => {
        if (pot.donation) {
          pot.donation['status_formatted'] = this.mangopayPaiementStatuses.has(
            pot.donation.status
          )
            ? this.mangopayPaiementStatuses.get(pot.donation.status)
            : '';
        }
        pot.closing_date = moment.utc(pot.closing_date).format('DD/MM/YYYY');
        this.jackpotsFiltered.push(pot);
      });

      this.jackpots = this.jackpotsFiltered;

      this.count = data.meta.pagination.total_objects;
      this.loaderService.hide();
    });
  }

  onEdit(jackpot: Jackpot) {
    this.router.navigate(['/cagnottes', jackpot.id]);
  }

  cellColor(car) {
    return (
      'rgb(255, 255,' +
      (155 + Math.floor(100 - ((car.rating - 8.7) / 1.3) * 100)) +
      ')'
    );
  }

  onJackpotsFiltered() {
    this.reload({
      event: this.eventSelected,
      limit: this.limit,
      offset: 0,
      pot_type: (({ company: 'ENTERPRISE', citizens: 'CITIZEN_SILVER' } as { [key: string]: string })[this.potType] || this.potType.toUpperCase()),
      search: this.jackpotFilter,
      sortBy: 'created_at',
      sortAsc: false,
      advanced_search: this.searchParams
    });
  }

  onFiltereByCategory(id: any) {
    // this.eventSelected = id;
    const params = <DataTableParams>Object.assign(
      {},
      {
        offset: 0,
        limit: this.limit,
        sortAsc: false,
        pot_type: (({ company: 'ENTERPRISE', citizens: 'CITIZEN_SILVER' } as { [key: string]: string })[this.potType] || this.potType.toUpperCase()),
        sortBy: 'created_at',
        event: id
      }
    );

    this.loaderService.show();
    this.cagnotteService.list(params).subscribe(data => {
      this.jackpotsFiltered = [];
      data.charity_pots.forEach((pot: Jackpot) => {
        if (pot.donation) {
          pot.donation['status_formatted'] = this.mangopayPaiementStatuses.has(
            pot.donation.status
          )
            ? this.mangopayPaiementStatuses.get(pot.donation.status)
            : '';
        }
        pot.closing_date = moment.utc(pot.closing_date).format('DD/MM/YYYY');
        this.jackpotsFiltered.push(pot);
      });
      this.jackpots = this.jackpotsFiltered;
      this.count = data.meta.pagination.total_objects;
      this.loaderService.hide();
    });
  }

  activate(jackpot: Jackpot) {
    this.cagnotteService.activateOrDeactivateCharityPot(jackpot).subscribe(data => {
      this.onJackpotsFiltered();
      const verb = data.is_active ? 'activ&eacute;e' : 'desactiv&eacute;e';
      this.toastyService.success({
        title: 'Success',
        msg: 'Cagnottes ' + verb,
        showClose: true,
        timeout: 5000,
        theme: 'bootstrap',
      });
    },
      () => this.toastyService.error({
        title: 'Attention',
        msg: 'Une erreur s\'est produite, reessayer plus tard',
        showClose: true,
        timeout: 5000,
        theme: 'bootstrap',
      }));

  }

  onSearchAdvanced(){
    const modalRef = this.modalService.open(CagnotteFilterComponent);
    modalRef.componentInstance.assocsForFilter = this.associations;
    modalRef.result.then((result) => {
      console.log('Search result:', result);
      if (result.hasOwnProperty('created_from')) {
        this.searchParams = Object.assign({}, {
          created_from: moment.utc(result['created_from']).local().startOf('day').format(),
          created_to: moment.utc(result['created_to']).local().endOf('day').format(),
          email: result['email'],
          assoc: result['assoc']
        });
        this.onJackpotsFiltered();
      } else {
      }
    }, err => console.log(err));
  }

  onExportData() {

    this.routeParams.limit = this.count;
    const jackpotsExported = [];

    this.loaderService.show();
    this.cagnotteService.list(this.routeParams).subscribe(data => {
      data.charity_pots.forEach((pot: Jackpot) => {
        let input = {};
        if (this.potType === 'company') {
          input = {
            'Dénomination sociale': pot.created_by && pot.created_by.entreprise && pot.created_by.entreprise.name ? pot.created_by.entreprise.name : '',
            'Siren': pot.created_by.entreprise.siren,
            'Forme légale': pot.created_by.entreprise.legal_form,
            'Adresse': pot.created_by && pot.created_by.entreprise && pot.created_by.entreprise.entreprise_address ? this.getAddress(pot.created_by.entreprise.entreprise_address) : '',
            'CCP': pot.created_by && pot.created_by.entreprise && pot.created_by.entreprise.entreprise_address && pot.created_by.entreprise.entreprise_address.post_code ? pot.created_by.entreprise.entreprise_address.post_code : '',
            'Ville': pot.created_by && pot.created_by.entreprise && pot.created_by.entreprise.entreprise_address && pot.created_by.entreprise.entreprise_address.city ? pot.created_by.entreprise.entreprise_address.city : '',
            'Pays': pot.created_by && pot.created_by.entreprise && pot.created_by.entreprise.entreprise_address && pot.created_by.entreprise.entreprise_address.country_iso ? pot.created_by.entreprise.entreprise_address.country_iso : '',
            'Représentant légal': pot.created_by.entreprise.representative ? pot.created_by.entreprise.representative.name + ' ' + pot.created_by.entreprise.representative.firstname : '',
            'Email du représentant légal': pot.created_by.entreprise.representative ? pot.created_by.entreprise.representative.email : '',
            'Contact': pot.created_by ? pot.created_by.name + ' ' + pot.created_by.firstname : '',
            'E-mail contact': pot.created_by && pot.created_by.email ? pot.created_by.email : '',
            'Téléphone contact': pot.created_by && pot.created_by.mob_phone ? pot.created_by.mob_phone : '',
            'Association soutenue': pot.assoc && pot.assoc.name ? pot.assoc.name : '',
            'Nom cagnotte': pot.name,
            'URL cagnotte': this.site_url + '/participate/' + pot.id,
            'Type d\'événement': pot.event_type && pot.event_type.name ? pot.event_type.name : '',
            'Créée le': moment.utc(pot.created_at).format('DD/MM/YYYY'),
            'Date de fin': moment.utc(pot.closing_date).format('DD/MM/YYYY'),
            'Montant des dons': pot.donations_total_amount,
            'Frais de service (HT)': pot.donations_total_service_fee / 1.2,
            'TVA (20%)': (pot.donations_total_service_fee - (pot.donations_total_service_fee / 1.2)),
            'Commission': pot.donations_total_commission,
            'Nombre de participants': pot.donators_count ? pot.donators_count : 0,
            'Date de dernière mise à jour': moment.utc(pot.updated_at).format('DD/MM/YYYY')
          }
        } else if(this.potType === 'private'){
          input = {
            'Civilité': pot.created_by && pot.created_by.gender ? this.getCivility(pot.created_by.gender) : '',
            'Nom': pot.created_by && pot.created_by.name ? pot.created_by.name : '',
            'Prénom': pot.created_by && pot.created_by.firstname ? pot.created_by.firstname : '',
            'Adresse': pot.created_by && pot.created_by.user_adress ? this.getAddress(pot.created_by.user_adress) : '',
            'CCP': pot.created_by && pot.created_by.user_adress && pot.created_by.user_adress.post_code ? pot.created_by.user_adress.post_code : '',
            'Ville': pot.created_by && pot.created_by.user_adress && pot.created_by.user_adress.city ? pot.created_by.user_adress.city : '',
            'Pays': pot.created_by && pot.created_by.user_adress && pot.created_by.user_adress.country_iso ? pot.created_by.user_adress.country_iso : '',
            'Date de naissance': pot.created_by && pot.created_by.birth_date ? moment.utc(pot.created_by.birth_date).format('DD/MM/YYYY') : '',
            'Adresse e-mail': pot.created_by && pot.created_by.email ? pot.created_by.email : '',
            'Téléphone': pot.created_by && pot.created_by.mob_phone ? pot.created_by.mob_phone : '',
            'Association soutenue': pot.assoc && pot.assoc.name ? pot.assoc.name : '',
            'Nom cagnotte': pot.name,
            'URL cagnotte': this.site_url + '/participate/' + pot.id,
            'Type d\'événement': pot.event_type && pot.event_type.name ? pot.event_type.name : '',
            'Créée le': moment.utc(pot.created_at).format('DD/MM/YYYY'),
            'Date de fin': moment.utc(pot.closing_date).format('DD/MM/YYYY'),
            'Montant des dons': pot.donations_total_amount,
            'Frais de service (HT)': pot.donations_total_service_fee / 1.2,
            'TVA (20%)': (pot.donations_total_service_fee - (pot.donations_total_service_fee / 1.2)),
            'Pourboires': pot.donations_total_gift,
            'Nombre de participants': pot.donators_count ? pot.donators_count : 0,
            'Date de dernière mise à jour': moment.utc(pot.updated_at).format('DD/MM/YYYY')
          };
        } else if (this.potType === 'citizens') {
          input = {
            'Civilité': pot.created_by && pot.created_by.gender ? this.getCivility(pot.created_by.gender) : '',
            'Nom': pot.created_by && pot.created_by.name ? pot.created_by.name : '',
            'Prénom': pot.created_by && pot.created_by.firstname ? pot.created_by.firstname : '',
            'Adresse': pot.created_by && pot.created_by.user_adress ? this.getAddress(pot.created_by.user_adress) : '',
            'CCP': pot.created_by && pot.created_by.user_adress && pot.created_by.user_adress.post_code ? pot.created_by.user_adress.post_code : '',
            'Ville': pot.created_by && pot.created_by.user_adress && pot.created_by.user_adress.city ? pot.created_by.user_adress.city : '',
            'Pays': pot.created_by && pot.created_by.user_adress && pot.created_by.user_adress.country_iso ? pot.created_by.user_adress.country_iso : '',
            'Date de naissance': pot.created_by && pot.created_by.birth_date ? moment.utc(pot.created_by.birth_date).format('DD/MM/YYYY') : '',
            'Adresse e-mail': pot.created_by && pot.created_by.email ? pot.created_by.email : '',
            'Téléphone': pot.created_by && pot.created_by.mob_phone ? pot.created_by.mob_phone : '',
            'Association soutenue': pot.assoc && pot.assoc.name ? pot.assoc.name : '',
            'Nom cagnotte': pot.name,
            'URL cagnotte': this.site_url + '/participate/' + pot.id,
            'Créée le': moment.utc(pot.created_at).format('DD/MM/YYYY'),
            'Date de fin': moment.utc(pot.closing_date).format('DD/MM/YYYY'),
            'Montant des dons': pot.donations_total_amount,
            'Frais de service (HT)': pot.donations_total_service_fee / 1.2,
            'TVA (20%)': (pot.donations_total_service_fee - (pot.donations_total_service_fee / 1.2)),
            'Comm. Citizens': pot.donations_total_commission_impact,
            'Nombre de participants': pot.donators_count ? pot.donators_count : 0,
            'Date de dernière mise à jour': moment.utc(pot.updated_at).format('DD/MM/YYYY')
          };
        } else {
          input = {
            'Civilité': pot.created_by && pot.created_by.gender ? this.getCivility(pot.created_by.gender) : '',
            'Nom': pot.created_by && pot.created_by.name ? pot.created_by.name : '',
            'Prénom': pot.created_by && pot.created_by.firstname ? pot.created_by.firstname : '',
            'Adresse': pot.created_by && pot.created_by.user_adress ? this.getAddress(pot.created_by.user_adress) : '',
            'CCP': pot.created_by && pot.created_by.user_adress && pot.created_by.user_adress.post_code ? pot.created_by.user_adress.post_code : '',
            'Ville': pot.created_by && pot.created_by.user_adress && pot.created_by.user_adress.city ? pot.created_by.user_adress.city : '',
            'Pays': pot.created_by && pot.created_by.user_adress && pot.created_by.user_adress.country_iso ? pot.created_by.user_adress.country_iso : '',
            'Date de naissance': pot.created_by && pot.created_by.birth_date ? moment.utc(pot.created_by.birth_date).format('DD/MM/YYYY') : '',
            'Adresse e-mail': pot.created_by && pot.created_by.email ? pot.created_by.email : '',
            'Téléphone': pot.created_by && pot.created_by.mob_phone ? pot.created_by.mob_phone : '',
            'Association soutenue': pot.assoc && pot.assoc.name ? pot.assoc.name : '',
            'Nom cagnotte': pot.name,
            'URL cagnotte': this.site_url + '/participate/' + pot.id,
            'Créée le': moment.utc(pot.created_at).format('DD/MM/YYYY'),
            'Date de fin': moment.utc(pot.closing_date).format('DD/MM/YYYY'),
            'Montant des dons': pot.donations_total_amount,
            'Frais de service (HT)': pot.donations_total_service_fee / 1.2,
            'TVA (20%)': (pot.donations_total_service_fee - (pot.donations_total_service_fee / 1.2)),
            'Comm. Students': pot.donations_total_commission_impact,
            'Nombre de participants': pot.donators_count ? pot.donators_count : 0,
            'Date de dernière mise à jour': moment.utc(pot.updated_at).format('DD/MM/YYYY')
          };
        }
        jackpotsExported.push(input);
      });

      this.downloadFile(jackpotsExported);
      this.loaderService.hide();
    });
  }

  private downloadFile(exportdata) {
    const csvData = this.convertToCSV(exportdata);
    const blob = new Blob([csvData], { type: 'text/csv' });
    const filename = 'export-cagnottes_' + moment().toISOString() + '.csv';
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveBlob(blob, filename);
    } else {
      const a = window.document.createElement('a');
      a.href = window.URL.createObjectURL(blob);
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }

  private convertToCSV(objArray) {
    const replacer = (_key, value) => value === null ? '' : value
    const header = Object.keys(objArray[0])
    let csv = objArray.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(';'))
    csv.unshift(header.join(';'));
    csv = csv.join('\r\n')
    return csv;
  }


  private getCivility(input: string): string {
    return input === 'male' ? 'M.' : 'Mme';
  }

  private getAddress(entrAddres): string {
    let address = '';
    let address_line_1 = entrAddres.address_line_1;
    let address_line_2 = entrAddres.address_line_2;

    if (address_line_1) {
      if (address_line_1.length > 0) {
        address = address_line_1;
      }
    }

    if (address_line_2) {
      if (address_line_2.trim.length > 0) {
        address += ' , ' + address_line_2;
      }
    }

    return address;
  }

}

interface SearchParam {
  created_from: string;
  created_to: string;
  email: string;
}
